<div class="wrapper flex flex-col justify-between">
  <div class="heading flex flex-row items-center justify-between mb-[40px]">
    <div class="text-type-2">
      {{ isEdit ? 'Edit punch list' : 'Create punch list' }}
    </div>
    @if (isEdit) {
      <button (click)="deletePunchlist()" class="delete-icon-button" aria-label="Delete punch list" [disabled]="saving">
        <mat-icon svgIcon="trash" class="text-red-500" />
      </button>
    }
  </div>

  <div class="details flex-1">
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['name']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="name"
      label="name"
    />
    <app-text-area
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['description']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="description"
      label="description"
    />
    <app-date-picker
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['start_date']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="start_date"
      label="start date"
    />
    <app-date-picker
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['completion_date']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="completion_date"
      label="completion date"
    />
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['prime_contractor_id']"
      [options]="contractorOptions"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="prime_contractor_id"
      label="prime contractor"
    />

    <div class="toggle-row mb-[40px]">
      <div class="label text-type-13 uppercase">Substantial completion</div>
      <mat-slide-toggle
        [formControl]="$any(form.get('substantial_completion'))"
        class="slide-toggle-btn"
        color="primary">
      </mat-slide-toggle>
    </div>

    <!-- Participants section: project users -->
    <div class="participants-section mb-[20px]">
      <div class="text-type-13 uppercase mb-[12px]">Participants</div>

      @if (selectedParticipants.length) {
        <div class="user-list mb-[16px]">
          @for (account of selectedParticipants; track account.account_id) {
            <div class="user-item flex flex-row items-center justify-between py-[8px]">
              <div class="flex flex-col">
                <span class="text-type-8">{{ account.first_name }} {{ account.last_name }}</span>
                <span class="text-type-14 text-[#60698B]">{{ account.email }}</span>
              </div>
              <button (click)="removeParticipant(account)" class="remove-user-btn">
                <mat-icon svgIcon="trash" />
              </button>
            </div>
            <hr class="hr-line" />
          }
        </div>
      }

      <app-dropdown
        [enableSearch]="true"
        [enableMultiple]="true"
        [showCount]="true"
        [selectionString]="'users'"
        [options]="participantOptions"
        [parentFormGroup]="participantSelectForm"
        class="w-full mb-[20px]"
        controlName="selectedParticipant"
        label="add participant"
        placeholder="Select"
      />
    </div>

    <!-- Notification users section: prime contractor users -->
    <div class="contractor-users-section mb-[20px]">
      <div class="text-type-13 uppercase mb-[12px]">Notification Users (Prime Contractor)</div>

      @if (selectedContractorAccounts.length) {
        <div class="user-list mb-[16px]">
          @for (account of selectedContractorAccounts; track account.account_id) {
            <div class="user-item flex flex-row items-center justify-between py-[8px]">
              <div class="flex flex-col">
                <span class="text-type-8">{{ account.first_name }} {{ account.last_name }}</span>
                <span class="text-type-14 text-[#60698B]">{{ account.email }}</span>
              </div>
              <button (click)="removeContractorAccount(account)" class="remove-user-btn">
                <mat-icon svgIcon="trash" />
              </button>
            </div>
            <hr class="hr-line" />
          }
        </div>
      }

      @if (!allContractorAccountOptions.length) {
        <div class="text-type-14 text-[#60698B] mb-[20px]">
          No contractor users on this project yet.
        </div>
      } @else {
        <app-dropdown
          [enableSearch]="true"
          [enableMultiple]="true"
          [showCount]="true"
          [selectionString]="'users'"
          [options]="contractorAccountOptions"
          [parentFormGroup]="contractorAccountSelectForm"
          class="w-full mb-[20px]"
          controlName="selectedContractorAccount"
          label="add notification user"
          placeholder="Select"
        />
      }
    </div>
  </div>

  <div class="action-section w-full flex justify-between items-center gap-[10px] mt-[40px]">
    <app-primary-button (handleClick)="submit()" [isDisabled]="form.invalid || saving" [isLoading]="saving" class="w-full">
      {{ isEdit ? 'Update' : 'Create' }}
    </app-primary-button>
  </div>
</div>
